export default {
  degree: {
    id: '',
    code: '',
    nameLocal: '',
    nameEng: '',
  },
  degrees: [],
  processing: false,
  error: null,
  success: null,
}



